export function formatCommentTimestamp(iso8601: string): string {
  if (Number.isNaN(Date.parse(iso8601))) {
    return "Unknown time";
  }
  return `${iso8601.slice(0, 10)} ${iso8601.slice(11, 16)} UTC`;
}

export function formatUtcDate(iso8601: string): string {
  if (Number.isNaN(Date.parse(iso8601))) {
    return "";
  }
  return iso8601.slice(0, 10);
}
